import React from "react";

const TopSponsor = () => {
  return (
    <div className="top_Sponsor_Panel py-1">
      <div className="container">
        <div className="top_Sponsor_Inner_Panel d-flex justify-content-between">
          <div className="sponsor_Wrapper d-none gap-3">
            <p>Sponsored by:</p>
            <div className="sponsor-block-wrapper d-flex gap-2">
              <div className="sponsor_Block"></div>
              <div className="sponsor_Block"></div>
              <div className="sponsor_Block"></div>
            </div>
          </div>
          <span></span>
          <a
            href="https://www.cowboychannelplus.com/Account/Signup"
            target="_blank"
            className="link_Text_Grey font_Secondary custom-tooltip"
            rel="noreferrer"
            data-tooltip="Subscribe to Cowboy Channel+"
          >
            Subscribe
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopSponsor;
